var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemoveSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50174 17.2134C12.8325 17.2134 16.3433 13.7026 16.3433 9.37185C16.3433 5.04107 12.8325 1.53027 8.50174 1.53027C4.17095 1.53027 0.660156 5.04107 0.660156 9.37185C0.660156 13.7026 4.17095 17.2134 8.50174 17.2134Z",
    fill: "#EC5C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.8721C3.81348 17.8721 0 14.0593 0 9.37207C0 4.68555 3.81348 0.87207 8.5 0.87207C13.1872 0.87207 17 4.68555 17 9.37207C17 14.0593 13.1872 17.8721 8.5 17.8721ZM8.5 2.18887C4.53903 2.18887 1.3168 5.4111 1.3168 9.37207C1.3168 13.333 4.53903 16.5553 8.5 16.5553C12.461 16.5553 15.6832 13.3324 15.6832 9.37207C15.6832 5.4111 12.461 2.18887 8.5 2.18887Z",
    fill: "#EC5C52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7932 9.97113H5.2092C4.84576 9.97113 4.55078 9.67615 4.55078 9.31271C4.55078 8.94927 4.84576 8.6543 5.2092 8.6543H11.7932C12.1574 8.6543 12.4517 8.94927 12.4517 9.31271C12.4517 9.67615 12.1574 9.97113 11.7932 9.97113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveSector);
export default __webpack_public_path__ + "static/media/iconRemoveSector.ac579bc1246992ca9b3f2d3e23e9b3b8.svg";
export { ForwardRef as ReactComponent };